/*模块功能注册*/
let curFuncId = '';//当前功能id
let curFuncObj =  "";//当前功能对象
let funcArr = [];//功能对象数组，

export default {
  /**
   * 模块功能注册
   * @param {String} funcId 功能名称
   * @param {Object} funcObj  功能对象
   */
  registerFunc(funcId, funcObj) {
    let findExit = funcArr.findIndex(item => {return item.funcId === funcId});
    if(findExit > -1){
      funcArr.splice(findExit,1);
    }
    funcArr.push({'funcId': funcId, 'funcObj': funcObj});
  },

  /**
   * 重新初始化模块注册中心
   */
  resetFuncMenu(){
    curFuncId = '';
    funcArr = [];
    curFuncObj = "";
  },

  /**
   * 返回所有已注册的功能名称
   * @returns {Array}
   */
  getRegisteredNames(){
    let res = [];
    funcArr.forEach(item => {res.push(item.funcId)});
    return res;
  },

  /**
   * 模块功能激活
   * @param funcId  功能名称
   * @param handleRepeatFun  重复点击是否关闭
   * @param method  重复点击情况下执行的回调函数
   * @returns {string}
   */
  activeFunc(funcId,handleRepeatFun =  true,method,params) {
    //找funcId对应的功能对象
    let funcObj = funcArr.find(item => {
      return item.funcId === funcId;
    });
    //功能未注册
    if (!funcObj) {return `无${funcId}功能!`;}

    //功能重复点击
    if (funcObj.funcId === curFuncId && handleRepeatFun) {
      //重复点击，则关闭当前激活的功能
      curFuncObj.funcObj.inActive();
      curFuncId = "";
      curFuncObj = "";
      if(method){
        method();
      }
      return;
    }
    /*激活本次需要的功能*/
    funcObj.funcObj.active(params);
    curFuncId = funcId;
    curFuncObj = funcObj;
  },

  /**
   * 卸载当前模块
   */
  inActiveCurModule() {
    if (curFuncObj) {
      curFuncObj.funcObj.inActive();
      curFuncId = "";
      curFuncObj = "";
    }
  },


  /**
   * 执行当前功能的Clear函数
   */
  clearCurrent() {
    if (curFuncObj) {
      curFuncObj.funcObj.clear();
    }
  },


  /**
   * 获取当前激活状态功能的ID
   */
  getCurFuncObj() {
    return curFuncObj;
  },

  /**
   * 获取当前激活功能的ID
   * @returns {string}
   */
  getCurFuncId(){
    return curFuncId;
  },

  /**
   * 通过功能ID查找功能实例
   * @param funcId
   */
  getFuncById(funcId){
    if(funcId){
      return funcArr.find(item => {return item.funcId === funcId});
    }
    return "";
  },

  /**
   * 通过功能ID执行该功能的clear函数
   * @param  param 空或者非空,
   */
  clearByFuncId(funcId) {
    if (funcId) {
      let res = this.getFuncById(funcId);
      if(res){res.funcObj.clear();}
    }
  },

  findObjById(funcId) {//通过模块的注册ID查找模块对象
    let obj = funcArr.find(function (func) {//通过功能ID在挂载功能注册中心查找功能实例
      return func.funcId === funcId;
    });
    return obj;
  },



}



// WEBPACK FOOTER //
// ./src/common/funcMenu.js